let calcChildSize = {
    init: () => {
        document.body.style.setProperty("--calc-height", "auto");
        // document.body.style.setProperty("--calc-width", "auto");

        const calcHeightTargets = document.getElementsByClassName("js-calcChildHeight");
        // const calcWidthTargets = document.getElementsByClassName("js-calcWidth");
        const resize = () => {
            for (let target of calcHeightTargets) {
                const firstChild = target.firstElementChild;
                if(firstChild) {
                    let size = firstChild.clientHeight + "px";
                    if (target.style.getPropertyValue("--calc-height") !== size) {
                        target.style.setProperty("--calc-height", size);
                    }
                }
            }

        //     for (let target of calcWidthTargets) {
        //         const position = target.dataset.position;
        //         const rect = target.getBoundingClientRect();
        //         const leftWidth = document.body.clientWidth - rect.left;
        //         if (leftWidth > rect.right) {
        //             const width = leftWidth + "px";
        //             target.dataset.position = 'left';
        //             if (target.style.getPropertyValue("--calc-width") !== width) {
        //                 target.style.setProperty("--calc-width", width);
        //             }
        //         } else {
        //             const width = rect.right + "px";
        //             target.dataset.position = 'right';
        //             if (target.style.getPropertyValue("--calc-width") !== width) {
        //                 target.style.setProperty("--calc-width", width);
        //             }
        //         }
        //     }
        };

        window.addEventListener("resize", resize);
        window.addEventListener("load", resize);
    }
}

export default calcChildSize;